import makeMainView from "../../shared/containers/make_main_view";

import Overview from "./main_components/overview";
import ParameterDetail from "./main_components/parameter_detail";
import { FOCUS_VIEW_TYPES } from "../actions/focus_view";

const mainComponents = {
  overview: Overview,
  parameterDetail: ParameterDetail
};

export default makeMainView(mainComponents, FOCUS_VIEW_TYPES, { overview: true, parameterDetail: true });
